// This schema is used to faciliate section prefilling for the 9141

export const sectionTitles = [
  {
    name: "Employment Based Visa Information",
    prefix: "A",
  },
  {
    name: "Employer Point-of-Contact Information",
    prefix: "B",
  },
  {
    name: "Employer Information",
    prefix: "C",
  },
  {
    name: "Attorney or Agent Information",
    prefix: "D",
  },
  {
    name: "Wage Source Information",
    prefix: "E",
  },
  {
    name: "Job Description",
    prefix: "F.a",
  },
  {
    name: "Minimum Job Requirements and/or Alternative Job Requirements",
    prefix: "F.b/c",
  },
  {
    name: "Other Information",
    prefix: "F.d",
  },
  {
    name: "Place of Employment Information",
    prefix: "F.e",
  },
  {
    name: "Additional Worksites",
    prefix: "APX A",
  },
];

export default {
  A: ["visaType"],
  B: [
    "requestorPocLastName",
    "requestorPocFirstName",
    "requestorPocMiddleName",
    "requestorPocJobTitle",
    "requestorPocAddr1",
    "requestorPocAddr2",
    "requestorPocCity",
    "requestorPocState",
    "requestorPocPostalCode",
    "requestorPocCountry",
    "requestorPocProvince",
    "requestorPocPhone",
    "requestorPocPhoneExt",
    "requestorPocFaxNumber",
    "requestorPocEmail",
  ],
  C: [
    "empBusinessName",
    "empTradeName",
    "empAddr1",
    "empAddr2",
    "empCity",
    "empState",
    "empPostcode",
    "empCountry",
    "empProvince",
    "empPhone",
    "empPhoneext",
    "empFein",
    "empNaics",
    "empNaicsDesc",
  ],
  D: [
    "attyRepresentType",
    "attyLastname",
    "attyFirstname",
    "attyMiddlename",
    "attyAddr1",
    "attyAddr2",
    "attyCity",
    "attyState",
    "attyPostcode",
    "attyCountry",
    "attyProvince",
    "attyPhone",
    "attyPhoneext",
    "attyEmail",
    "attyBizname",
    "attyFein",
  ],
  E: [
    "coveredByAcwia",
    "acwiaHigherEdu",
    "acwiaAffiliated",
    "acwiaNonprofit",
    "acwiaStatusChange",
    "sportsLeague",
    "cba",
    "pre_dbaSca",
    "dbaSurvey",
    "survey",
    "surveyName",
    "surveyPublicationDate",
  ],
  "F.a": ["jobTitle", "jobDuties", "superviseOtherEmp", "supervisedSocs"],
  "F.b/c": [
    "primaryEducationLevel",
    "otherEducation",
    "major",
    "secondDiploma",
    "secondDiplomaMajor",
    "trainingRequired",
    "numberOfMonthsTraining",
    "nameRequiredTraining",
    "empExperienceRequired",
    "empExperienceMonths",
    "occupationRequired",
    "specialRequirements",
    "isSpecialRequirements",
    "isSpecReqLicenseCert",
    "specReqLicenseCert",
    "isSpecReqForeignLang",
    "specReqForeignLang",
    "isSpecReqResFellow",
    "specReqResFellow",
    "isSpecReqOther",
    "specReqOther",

    "altJobRequirement",
    "altEducationLevel",
    "altOtherEdu",
    "altMajor",
    "altTrainingReq",
    "altNumMonthsTraining",
    "altNameReqdTraining",
    "altEmpExperienceReqd",
    "altEmpExpNumMonths",
    "isAltSpecialReq",
    "isAltSpecReqLicenseCert",
    "altSpecReqLicenseCert",
    "isAltSpecReqForeignLang",
    "altSpecReqForeignLang",
    "isAltSpecReqResFellow",
    "altSpecReqResFellow",
    "isAltSpecReqOther",
    "altSpecReqOther",
  ],
  "F.d": [
    "suggestedSocCode",
    "suggestedSocTitle",
    "supervisorJobTitle",
    "travelRequired",
    "travelDetails",
  ],
  "F.e": [
    "primaryWorksiteAddr1",
    "primaryWorksiteAddr2",
    "primaryWorksiteCity",
    "primaryWorksiteCounty",
    "primaryWorksiteState",
    "primaryWorksiteBlsArea",
    "primaryWorksitePostalCode",
    "otherWorksiteLocation",
  ],
  "APX A": ["otherWorksites"],
};
